import React from 'react';
import { Center, Checkbox, Flex, Icon, Tooltip } from '@chakra-ui/react';
import '../styles/checkbox.css';
import { TooltipText } from '@/ui/TooltipText';
import { KFormLabel } from '@/ui-library/components';
import { InfoCircle } from '@kula-ai/icons-core';

export const CheckboxField = ({ item, field }) => {
  if (!item) return null;
  const {
    name,
    isEditable = true,
    label,
    style,
    subLabel,
    subLabelStyles,
    labelStyles,
    labelInfoText,
    defaultChecked,
    onCheckedChange = () => {},
    truncationLength = 0,
    disabled,
  } = item;

  const defaultStyles = {
    borderRadius: '8px',
  };

  const handleChange = (e) => {
    const isChecked = e.target.checked;
    if (field.onChange) {
      field.onChange(e);
    }
    onCheckedChange(isChecked);
  };

  return (
    <>
      <Checkbox
        className="custom_checkbox"
        {...field}
        style={{ ...defaultStyles, ...style }}
        id={name}
        isChecked={field?.value || false}
        isDisabled={!isEditable}
        disabled={disabled}
        _hover={{ '& > span': { background: 'transparent' } }}
        _checked={{ '& > span': { backgroundColor: 'transparent' } }}
        defaultChecked={defaultChecked}
        onChange={handleChange}
      >
        <Flex>
          {label && (
            <KFormLabel
              cursor="pointer"
              htmlFor={name}
              style={{ ...labelStyles }}
              mb="0"
            >
              {truncationLength === 0 ? (
                label
              ) : (
                <TooltipText
                  variant="default"
                  text={label}
                  stringLength={truncationLength}
                />
              )}
            </KFormLabel>
          )}
          {labelInfoText && (
            <Tooltip variant="default" label={labelInfoText}>
              <Center ml="-6px" w="18px" h="18px">
                <Icon
                  color={'secondary-700'}
                  as={InfoCircle as React.ElementType}
                />
              </Center>
            </Tooltip>
          )}
        </Flex>
      </Checkbox>
      {subLabel && (
        <KFormLabel
          htmlFor={name}
          style={{ ...subLabelStyles }}
          variant="subLabel"
          ml="24px"
          requiredIndicator={null}
        >
          {subLabel}
        </KFormLabel>
      )}{' '}
    </>
  );
};
